// extracted by mini-css-extract-plugin
module.exports = {"main":"HomePage_main__1haU1","container":"HomePage_container__d1YAB"};